<template>
  <Teleport to="body">
    <div
      v-if="open"
      class="fixed inset-0 z-[10060] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
      @keydown.escape.window="$emit('cancel')"
    >
      <div class="cliente-submodal bg-white dark:bg-gray-800 shadow-2xl w-full max-w-md border border-gray-200 dark:border-gray-700 flex flex-col">
        <header class="cliente-submodal__header">
          <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-red-500 to-rose-600 flex items-center justify-center shadow-md shrink-0">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <div>
            <h3 :id="titleId" class="text-lg font-bold text-gray-900 dark:text-white">{{ title }}</h3>
            <p v-if="message" class="text-sm text-gray-500 dark:text-gray-400 mt-1">{{ message }}</p>
          </div>
        </header>

        <footer class="cliente-submodal__footer flex justify-end gap-2">
          <button
            type="button"
            class="px-4 py-2 text-sm font-semibold rounded-[4px] border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
            :disabled="loading"
            @click="$emit('cancel')"
          >
            {{ t('common.cancel') }}
          </button>
          <button
            type="button"
            class="px-4 py-2 text-sm font-semibold rounded-[4px] bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
            :disabled="loading"
            @click="$emit('confirm')"
          >
            {{ loading ? t('common.loading') : (confirmLabel || t('common.delete')) }}
          </button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

defineProps({
  open: { type: Boolean, default: false },
  title: { type: String, required: true },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  titleId: { type: String, default: 'cliente-confirm-title' }
})

defineEmits(['cancel', 'confirm'])

const { t } = useI18n()
</script>

<style scoped>
.cliente-submodal {
  border-radius: 4px;
}
.cliente-submodal__header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1.25rem 1.25rem 0.75rem;
}
.cliente-submodal__footer {
  padding: 0.75rem 1.25rem 1.25rem;
}
</style>
